import { createNamespacedHelpers } from 'vuex';

import TabMenu from '@/components/tab_menu/TabMenu.vue';
import SideBar from '@/components/side_bar/SideBar.vue';
import ChannelList from '@/components/channel_list/ChannelList.vue';
import MessageHeader from '@/components/message_header/MessageHeader.vue';
import MessageList from '@/components/message_list/MessageList.vue';
import ConciergeList from '@/components/concierge_list/ConciergeList.vue';
import MessageInput from '@/components/message_input/MessageInput.vue';
import UserInfo from '@/components/user_info/UserInfo.vue';
import Level from '@/global/level.directive';

const { mapState: mapChannelState } = createNamespacedHelpers('Channel');
const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');
const { mapState: mapUserState } = createNamespacedHelpers('User');

export default {
  components: {
    ChannelList,
    TabMenu,
    SideBar,
    MessageHeader,
    MessageList,
    ConciergeList,
    MessageInput,
    UserInfo
  },

  data: function() {
    return {
      showModal: false,
      isChannelMenuShown: false,
      tabMenu: {
        items: {
          own: {
            label: 'My Chats',
            count: 0,
            badge: 'grey'
          },
          waiting: {
            label: 'Waiting',
            count: 0,
            badge: 'red'
          },
          ...this.getConciergeTabMenuConfig()
        },
        currentTab: 'own'
      }
    };
  },

  computed: {
    ...mapChannelState({
      currentChannel: state => state.currentChannel,
      unreadChannels: state => state.unreadChannels
    }),

    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge,
      conciergeChannels: state => state.conciergeChannels,

      isAllowedAccess: function(state) {
        return state.currentConcierge.conciergeLevel >= 199;
      }
    }),

    ...mapUserState({
      currentUser: state => state.currentUser
    })
  },

  watch: {
    unreadChannels: function() {
      const count = Object.keys(this.unreadChannels).length || 0;
      if (count > 0) {
        this.tabMenu.items.own.badge = 'red';
        this.tabMenu.items.own.count = count;
        return;
      }

      this.tabMenu.items.own.badge = 'grey';
      this.tabMenu.items.own.count = 0;
    }
  },

  methods: {
    getConciergeTabMenuConfig: function() {
      return Level.canAccess('chat.concierges')
        ? {
            concierges: {
              label: 'Concierges',
              count: 0,
              badge: 'green'
            }
          }
        : {};
    },

    setChannelCount: function(channel) {
      const { tabName } = channel;
      // FIXME: refactor so it won't override our existing own count
      if (tabName === 'own') return;

      const { items } = this.tabMenu;
      items[channel.tabName].count = channel.count;
    },

    setConciergeCount: function(concierges) {
      const { items } = this.tabMenu;
      items.concierges.count = concierges.count;
    }
  }
};
